import { render, staticRenderFns } from "./qa.vue?vue&type=template&id=e806f8fa&scoped=true"
import script from "./qa.vue?vue&type=script&lang=ts"
export * from "./qa.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e806f8fa",
  null
  
)

export default component.exports